import { render, staticRenderFns } from "./MyDeliverySchedule.vue?vue&type=template&id=18d61d37&scoped=true&"
import script from "./MyDeliverySchedule.vue?vue&type=script&lang=js&"
export * from "./MyDeliverySchedule.vue?vue&type=script&lang=js&"
import style0 from "./MyDeliverySchedule.vue?vue&type=style&index=0&id=18d61d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d61d37",
  null
  
)

export default component.exports